import { FILE_MIME_TYPES } from "./constant";

export const detectMimeType = (base64String) => {
  for (const sign in FILE_MIME_TYPES) {
    if (base64String?.startsWith(sign)) {
      return FILE_MIME_TYPES[sign];
    }
  }
};
